export const BRAND_SUBMISSION_PROMOTION_TYPE = [`Rafaksi`, `Flash Sale`, `Rafaksi BMSM v2`]
